import React from 'react';
import PropTypes from 'prop-types';
import Button from 'reusecore/src/elements/Button';
import { openModal } from '@redq/reuse-modal';
import ReportModal from '../../containers/ModalContainer/ReportModal';
import report from '@core/ui/static/images/ico-abus.svg';
import { useTranslation } from 'next-i18next';

const Report = ({ ...props }) => {
  const { t } = useTranslation();

  const params = {
    config: {
      className: 'reportModal',
      width: 'auto',
      height: 'auto',
      enableResizing: false,
      disableDragging: true,
      transition: {
        tension: 150,
      },
    },
    withRnd: false,
    closeOnClickOutside: true,
    component: ReportModal,
    componentProps: {
      ...props,
    },
  };

  return (
    <div>
      <Button
        title={t('adsView.view.report.title')}
        variant="textButton"
        color="#0B2F3F"
        style={{
          textDecoration: 'none',
        }}
        iconPosition="left"
        icon={
          <img
            src={report}
            style={{ marginRight: '5px', marginTop: '-3px' }}
            alt=""
          />
        }
        onClick={() => openModal(params)}
      />
    </div>
  );
};

Report.propTypes = {
  ads: PropTypes.shape({
    title: PropTypes.string,
    sid: PropTypes.string,
  }).isRequired,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

Report.defaultProps = {
  userId: false,
};

export default Report;
